import React, { useState } from 'react';
import {
  FaAppleAlt,
  FaBell,
  FaCheckCircle,
  FaDumbbell,
  FaMoon,
  FaSun,
  FaWifi,
  FaDownload,
  FaMobileAlt,
  FaRobot,
} from 'react-icons/fa';

export default function DownloadApp() {
  const [dark, setDark] = useState(true);

  const bazaarUrl = 'https://cafebazaar.ir/app/ir.mogym.app';
  const myketUrl = 'https://myket.ir/app/ir.mogym.app.myket';

  return (
    <div dir="rtl" className={dark ? 'dark' : ''}>
      <div className="min-h-screen font-vazir bg-[#f8faff] dark:bg-[#070B14] text-slate-900 dark:text-white overflow-hidden">
        <div className="fixed top-24 right-[-80px] w-72 h-72 rounded-full bg-purple-500/20 blur-3xl pointer-events-none" />
        <div className="fixed top-80 left-[-80px] w-72 h-72 rounded-full bg-blue-500/20 blur-3xl pointer-events-none" />

        <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/75 dark:bg-[#0A0F1E]/80 border-b border-slate-200/70 dark:border-white/10">
          <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img src="/logo.png" alt="Mogym" className="w-12 h-12" />
              <div className="hidden sm:block">
                <div className="font-black text-lg">موجیم</div>
                <div className="text-xs text-slate-500 dark:text-slate-400">مربی هوشمند همیشه همراهت</div>
              </div>
            </a>

            <div className="flex items-center gap-2">
              <a
                href="/"
                className="px-4 py-2.5 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 text-sm font-bold"
              >
                نسخه وب
              </a>

              <button
                onClick={() => setDark((v) => !v)}
                className="w-10 h-10 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#111827] flex items-center justify-center"
              >
                {dark ? <FaSun /> : <FaMoon />}
              </button>
            </div>
          </div>
        </header>

        <main className="relative z-10">
          <section className="max-w-7xl mx-auto px-4 py-12 lg:py-20 grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-right">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-purple-500/20 bg-purple-500/10 text-purple-400 text-sm font-bold mb-6">
                <FaMobileAlt />
                اپلیکیشن اندروید موجیم
              </div>

              <h1 className="text-4xl md:text-6xl font-black leading-[1.35]">
                موجیم؛ مربی هوشمند شخصی همیشه همراهت
              </h1>

              <p className="mt-5 text-base md:text-lg leading-9 text-slate-600 dark:text-slate-300 max-w-2xl mx-auto lg:mx-0">
                برنامه تمرین و تغذیه ۱۰۰٪ اختصاصی بر اساس بدن، هدف، سبک زندگی و تجهیزات تو.
                برنامه را یک‌بار دریافت کن و بعد حتی بدون اینترنت از تمرین‌ها، رژیم و ویدئوها استفاده کن.
              </p>

              <div className="mt-7 grid sm:grid-cols-2 gap-3 max-w-xl mx-auto lg:mx-0">
                <DownloadButton
                  href={bazaarUrl}
                  title="دانلود از کافه‌بازار"
                  image="/bazaar.svg"
                  color="green"
                />

                <DownloadButton
                  href={myketUrl}
                  title="دانلود از مایکت"
                  image="/myket.svg"
                  color="blue"
                />

              </div>
              <div className="mt-8 grid sm:grid-cols-2 gap-3 text-right">
                <FeatureLine icon={<FaCheckCircle />} text="برنامه تمرین و تغذیه شخصی‌سازی‌شده با هوش مصنوعی" />
                <FeatureLine icon={<FaDumbbell />} text="ویدئوهای آموزشی حرکات برای اجرای صحیح تمرین" />
                <FeatureLine icon={<FaAppleAlt />} text="رژیم سازگار با سبک زندگی ایرانی و هدف بدنی تو" />
                <FeatureLine icon={<FaWifi />} text="استفاده از برنامه بعد از دریافت، حتی بدون اینترنت" />
                <FeatureLine icon={<FaBell />} text="یادآور تمرین و تغذیه برای حفظ نظم برنامه" />
                <FeatureLine icon={<FaRobot />} text="تحلیل اطلاعات بدنی برای ساخت خروجی دقیق‌تر" />
              </div>
            </div>

            <div className="flex justify-center lg:justify-start">
              <div className="relative w-[290px] sm:w-[360px]">
                <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-purple-500/25 blur-3xl" />
                <div className="absolute -bottom-8 -left-8 w-40 h-40 rounded-full bg-blue-500/25 blur-3xl" />

                <div className="relative rounded-[3rem] bg-[#050816] border-[8px] border-slate-900 shadow-2xl overflow-hidden p-4">
                  <div className="w-28 h-5 bg-black/70 rounded-full mx-auto mb-5" />

                  <div className="rounded-[2rem] bg-gradient-to-b from-[#0F172A] to-[#020617] p-5 min-h-[540px]">
                    <div className="flex items-center justify-between mb-8">
                      <span className="text-xs text-slate-400">باشگاهی به وسعت ایران</span>
                      <span className="text-sm font-black text-white">موجیم</span>
                    </div>

                    <div className="rounded-3xl bg-gradient-to-br from-purple-600 to-blue-500 p-5 text-white mb-5">
                      <div className="text-xs opacity-80 mb-2">برنامه امروز</div>
                      <div className="font-black leading-7">تمرین سینه و سرشانه + تغذیه روز سوم</div>
                    </div>

                    <MobileCard title="تمرین" desc="۶ حرکت، ۳ سوپرست، سطح متوسط" />
                    <MobileCard title="تغذیه" desc="۵ وعده، قابل جایگزینی، پر پروتئین" />
                    <MobileCard title="پیشرفت" desc="وزن: ۷۴ → ۷۱.۵ کیلو در ۳ هفته" />

                    <div className="mt-5 rounded-3xl border border-green-500/20 bg-green-500/10 p-4">
                      <div className="text-green-400 font-black text-sm">برنامه آماده اجراست</div>
                      <div className="text-green-200/80 text-xs mt-2 leading-5">
                        یک‌بار آنلاین باز کن، بعد آفلاین استفاده کن.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="max-w-7xl mx-auto px-4 py-12">
            <SectionTitle
              title="چرا نصب اپلیکیشن موجیم بهتره؟"
              subtitle="نسخه اپ برای استفاده روزانه، دسترسی سریع‌تر و همراهی داخل باشگاه طراحی شده"
            />

            <div className="grid md:grid-cols-3 gap-5">
              <InfoCard
                title="همیشه همراه تمرین"
                body="برنامه تمرین، توضیحات و ویدئوها را مستقیم در باشگاه یا خانه همراهت داری."
              />
              <InfoCard
                title="تمرین بدون وابستگی به اینترنت"
                body="بعد از دریافت برنامه، بخش زیادی از مسیرت حتی در حالت آفلاین هم قابل استفاده است."
                featured
              />
              <InfoCard
                title="تجربه بهتر از وب"
                body="یادآورها، مشاهده سریع برنامه روزانه و دسترسی راحت‌تر به جزئیات، داخل اپ بهتر انجام می‌شود."
              />
            </div>
          </section>

          <section className="max-w-5xl mx-auto px-4 py-12">
            <div className="rounded-[2rem] bg-gradient-to-br from-purple-950 to-slate-900 border border-purple-500/20 text-white p-8 md:p-10 text-center shadow-2xl">
              <FaDownload className="mx-auto text-4xl text-purple-300 mb-5" />
              <h2 className="text-3xl md:text-4xl font-black">همین حالا موجیم رو نصب کن</h2>
              <p className="mt-4 leading-8 text-slate-300 max-w-2xl mx-auto">
                هدفت رو وارد کن، برنامه اختصاصی‌ات رو بگیر و تمرین رو با مسیر مشخص شروع کن.
              </p>

<div className="max-w-xl mx-auto mt-7">
  
  <div className="grid sm:grid-cols-2 gap-3">
    <DownloadButton
      href={bazaarUrl}
      title="دانلود از کافه‌بازار"
      subtitle="پیشنهاد اصلی"
      image="/bazaar.svg"
      color="green"
    />

    <DownloadButton
      href={myketUrl}
      title="دانلود از مایکت"
      subtitle="جایگزین نصب"
      image="/myket.svg"
      color="blue"
    />
  </div>
</div>
            </div>
          </section>
        </main>

        <footer className="relative z-10 max-w-7xl mx-auto px-4 pb-8">
          <div className="rounded-[2rem] bg-white dark:bg-[#10182A] border border-slate-200 dark:border-white/10 p-6 text-center">
            <div className="font-black text-xl">موجیم</div>
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              اولین اپلیکیشن هوشمند برنامه‌ساز ایرانی
            </p>

            <div className="flex justify-center gap-5 flex-wrap mt-5 text-sm">
              <a href="/terms">شرایط و مقررات</a>
              <a href="/faq">سوالات متداول</a>
              <a href="/contact-us">ارتباط با ما</a>
              <a href="/">نسخه وب</a>
            </div>

            <div className="mt-5 pt-5 border-t border-slate-200 dark:border-white/10 text-xs text-slate-400">
              © {new Date().getFullYear()} Mogym. تمام حقوق محفوظ است
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

function DownloadButton({ href, title, subtitle, image, color }) {
  const colorClasses =
    color === 'green'
      ? 'hover:border-green-400 hover:shadow-green-500/20'
      : 'hover:border-blue-400 hover:shadow-blue-500/20';

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`group flex items-center justify-center gap-3 rounded-2xl bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 px-5 py-4 shadow-lg transition hover:scale-[1.02] ${colorClasses}`}>
      <img
        src={image}
        alt={title}
        className="w-10 h-10 object-contain"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
      <div className="text-right">
        <div className="font-black text-slate-900 dark:text-white">{title}</div>
        <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">{subtitle}</div>
      </div>
    </a>
  );
}

function FeatureLine({ icon, text }) {
  return (
    <div className="flex items-start gap-2 rounded-2xl bg-white dark:bg-white/[0.04] border border-slate-200 dark:border-white/10 p-3">
      <span className="mt-1 text-green-500 shrink-0">{icon}</span>
      <span className="text-sm leading-7 text-slate-700 dark:text-slate-200">{text}</span>
    </div>
  );
}

function MobileCard({ title, desc }) {
  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-4 mb-3">
      <div className="text-slate-200 font-bold text-sm">{title}</div>
      <div className="text-slate-400 text-xs mt-2">{desc}</div>
    </div>
  );
}

function InfoCard({ title, body, featured }) {
  return (
    <div
      className={`rounded-[2rem] p-6 border shadow-lg ${
        featured
          ? 'bg-gradient-to-br from-purple-50 to-blue-50 dark:from-[#241846] dark:to-[#10182E] border-purple-500/25'
          : 'bg-white dark:bg-[#10182A] border-slate-200 dark:border-white/10'
      }`}
    >
      <h3 className="text-xl font-black">{title}</h3>
      <p className="mt-3 leading-8 text-sm text-slate-500 dark:text-slate-400">{body}</p>
    </div>
  );
}

function SectionTitle({ title, subtitle }) {
  return (
    <div className="text-center mb-8">
      <h2 className="text-2xl md:text-4xl font-black">{title}</h2>
      <p className="mt-3 text-sm md:text-base text-slate-500 dark:text-slate-400 leading-8 max-w-2xl mx-auto">
        {subtitle}
      </p>
    </div>
  );
}